import { Navigate, useParams } from 'react-router-dom';

import { LEGACY_PARAM_REDIRECTS, ROUTES } from '@/config/routes';

import { REPLACE_HISTORY } from './LegacyRedirect.constants';
import type { LegacyRedirectProps } from './LegacyRedirect.types';

/** Sends an old parameterised path to its new home, carrying the matched params over. */
export const LegacyRedirect = ({ from }: LegacyRedirectProps) => {
	const params = useParams();
	const entry = LEGACY_PARAM_REDIRECTS.find((redirect) => redirect.from === from);

	return <Navigate to={entry ? entry.to(params) : ROUTES.today} replace={REPLACE_HISTORY} />;
};
